import axios from 'axios';
import { Message } from '../models/chat';

const baseURL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const fetchConversation = async (
  conversationId: string
): Promise<Message[]> => {
  const { data } = await api.get<Message[]>(`/api/convo/history`, {
    params: {
      conversationId,
    },
  });
  return data;
};

export const initialMessage = async (conversationId: string): Promise<void> => {
  try {
    const requestBody = {
      userTrackedId: conversationId,
      assistantName: null,
    };

    const { data } = await api.post('/api/convo', JSON.stringify(requestBody), {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error) {
    console.error('Error sending message:', error);
    return undefined;
  }
};

type OnDataChunkCallback = (chunk: string) => void;

export const sendMessage = async (
  conversationId: string,
  textMessage: string,
  onDataChunk: OnDataChunkCallback
): Promise<void> => {
  try {
    const response = await fetch(
      `${baseURL}/api/convo/text?UserTrackedId=${conversationId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(textMessage),
      }
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const reader = response.body?.getReader();
    const decoder = new TextDecoder('utf-8');

    // Check if the reader is defined
    if (reader) {
      while (true) {
        const { done, value } =
          (await reader.read()) as ReadableStreamReadResult<Uint8Array>;
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });

        onDataChunk(chunk);
      }
    }
  } catch (error) {
    console.error('Error sending message:', error);
  }
};

export const sendAudioBuffer = async (
  conversationId: string,
  voice: string,
  audioBlob: Blob
): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('audio', audioBlob, 'recording.wav');

    const response = await fetch(
      `${baseURL}/api/convo/audio/stream/v2?UserTrackedId=${conversationId}&ShouldRemuxAudio=true&Voice=${voice}`,
      {
        method: 'POST',
        body: formData,
      }
    );

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    return url;
  } catch (error) {
    console.error('Error sending audio:', error);
    throw new Error('Error while sending audio');
  }
};
